export default "/images/98b887cf5dedcd149b80ade9f154597f.avif";